import React, { useEffect, useState } from 'react';
import { Wrench, ShieldCheck, Users } from 'lucide-react';
import '../styles/AdminOperations.css';
const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;
function useOperations(token, refresh = 0) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    fetch(`${API}/admin/maintenance`, {headers: {Authorization: `Bearer ${token}`}, cache: 'no-store'})
      .then(r => { if (!r.ok) throw new Error('Status kon niet worden geladen.'); return r.json(); })
      .then(d => { if (active) { setData(d); setError(''); } })
      .catch(e => { if (active) setError(e.message); });
    return () => { active = false; };
  }, [token, refresh]);
  return {data, error};
}
export function OperationsOverview({token, refresh}) {
  const {data, error} = useOperations(token, refresh);
  const cards = [['Gebruikers', data?.users], ['Actieve accounts', data?.active_users],
    ['Beheerders', data?.admins], ['Nieuwe toegang', data ? (data.enabled ? 'Gepauzeerd' : 'Open') : null]];
  return <><div className="operations-overview">{cards.map(([label,value]) =>
    <div className="operations-card" key={label}><span>{label}</span><strong>{value ?? '…'}</strong>
    <small>{label === 'Nieuwe toegang' ? 'Inloggen & registreren' : 'KRYPTON9 platform'}</small></div>)}</div>
    {error && <p role="alert">{error}</p>}</>;
}
export function MaintenancePanel({token, onChanged}) {
  const {data, error} = useOperations(token);
  const [busy, setBusy] = useState(false); const [failure, setFailure] = useState('');
  async function toggle() {
    if (!data || busy) return;
    setBusy(true); setFailure('');
    try {
      const r = await fetch(`${API}/admin/maintenance`, {method:'PUT',
        headers:{Authorization:`Bearer ${token}`, 'Content-Type':'application/json'},
        body:JSON.stringify({enabled: !data.enabled})});
      if (!r.ok) throw new Error('Opslaan mislukt. Vernieuw om de actuele status te controleren.');
      onChanged();
    } catch(e) { setFailure(e.message); } finally { setBusy(false); }
  }
  return <section className="maintenance-panel">
    <div className="maintenance-panel-heading"><Wrench size={24}/><div><span className="ops-eyebrow">PLATFORM CONTROL</span>
    <h2>Onderhoud & toegang</h2></div></div>
    <p>Pauzeer nieuwe aanmeldingen en registraties terwijl je aan KRYPTON9 werkt.</p>
    {(error || failure) && <p role="alert" className="admin-login-error">{error || failure}</p>}
    <div className="maintenance-control"><div><h3>Maintenance mode</h3>
    <p>{data ? (data.enabled ? 'Actief: nieuwe gebruikerstoegang is gepauzeerd.' : 'Uit: gebruikers kunnen inloggen en registreren.') : 'Status laden…'}</p></div>
    <button type="button" role="switch" aria-checked={data?.enabled === true} aria-label="Maintenance mode"
      className={`maintenance-switch ${data?.enabled ? 'enabled' : ''}`} onClick={toggle} disabled={!data || busy || !!error}>
      <span/>{busy ? 'Opslaan…' : data?.enabled ? 'AAN' : 'UIT'}</button></div>
    <div className="maintenance-notes"><p><ShieldCheck size={18}/> Beheerders houden toegang via /admin.</p>
      <p><Users size={18}/> Bestaande sessies worden niet uitgelogd.</p></div>
    <div className="maintenance-preview"><span className="ops-eyebrow">VOORBEELD / ENGLISH</span>
      <Wrench size={30}/><h3>Making KRYPTON9 even better.</h3>
      <p>We are upgrading the platform. Sign-in and registration are temporarily paused. Please check back shortly. Thank you for your patience.</p></div>
    <p className="admin-subtitle">Bezoekers zien de melding automatisch in NL of EN.</p>
    <p className="admin-subtitle">{data?.updated_at ? `Laatst gewijzigd: ${new Date(data.updated_at).toLocaleString('nl-NL')}` : 'Nog geen onderhoudswijzigingen.'}</p>
  </section>;
}
